export const round = (value: number) => (
  Math.round(value * 100) / 100
)

export const formatNumber = (value: number | string) => {
  if (
    (typeof value === 'string')
    && !(/^\d+(?:\.\d*)?$/).test(value)
  ) {
    return value
  }
  const v: number = (+value || 0)
  if (v >= 1000000000000) return `${round(v / 1000000000000)}T`
  if (v >= 1000000000) return `${round(v / 1000000000)}B`
  if (v >= 1000000) return `${round(v / 1000000)}M`
  if (v >= 1000) return `${round(v / 1000)}K`
  return String(round(v))
}

const formatSmallNumber = (num: number | string) => {
  const str = typeof num === 'number' ? num.toFixed(10) : num;

  const dotPosition = str.indexOf('.');
  if (dotPosition === -1) return str; // Если нет дробной части, возвращаем исходное число

  // Находим первую ненулевую цифру после точки
  // eslint-disable-next-line no-useless-escape
  const nonZeroMatch = str.substr(dotPosition).match(/[^0\.]/);

  if (!nonZeroMatch) return str; // Если после точки только нули, возвращаем исходное число

  const firstNonZeroPosition = nonZeroMatch.index || 0;

  // Определяем позицию после 2 значащих цифр
  const endPosition = dotPosition + firstNonZeroPosition + 2;

  return str.substring(0, endPosition).replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.$/, '');
}

export const formatMoney = (value: number | undefined) => {
  if (!value) {
    return 0
  }

  if (value < 1) {
    return formatSmallNumber(value)
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  const string = (Math.round((value) * 100) / 100).toLocaleString('en-US', { maximumFractionDigits: 2 })
  if (string.split('.')[1]?.length < 2) {
    return `${string}0`
  }
  return string
}

export const formatDescription = (desc: string) => {
  const numbDesc = +desc

  if (Number.isNaN(numbDesc) || desc.length === 4) {
    return desc
  }

  return formatMoney(numbDesc)
}

export const formatAssetStat = (
  stat: number | string | undefined,
  isShort?: boolean,
  isPercent?: boolean,
) => {
  if (stat === undefined || stat === null) {
    return ''
  }
  const value = +stat
  if (Number.isNaN(value)) {
    return stat
  }

  if (value === 0) {
    return 0
  }

  if (isPercent) {
    return formatNumber(value)
  }

  if (isShort) {
    return (Math.abs(value) > 0.01 ? formatNumber(value) : formatSmallNumber(value))
  }

  return (Math.abs(value) > 0.01 ? formatMoney(value) : formatSmallNumber(value))
}

export const getItemSuffix = (item: string, stat: number | string) => {
  if (item === 'Dividient yield' || item === 'Price-Earnings Ratio' || item === 'Beta') {
    return ''
  }

  if (Number.isNaN(+stat)) {
    return ''
  }
  return '$'
}
export const getItemPostffix = (item: string) => {
  if (item === 'Dividient yield') {
    return '%'
  }

  return ''
}
